import React, { Component } from 'react'

import classNames from './ArrayPicker.css'

export default class ArrayPicker extends Component {
  static defaultProps = {
    selected: []
  }
  renderItem = item => {
    const { selected, onChange } = this.props
    const active = selected.indexOf(item) !== -1
    const onClick = () => {
      if (active) {
        if (selected.length === 1) {
          onChange(undefined)
        } else {
          onChange(selected.filter(value => value !== item))
        }
      } else {
        onChange(selected.concat(item))
      }
    }
    return (
      <button
        key={item}
        className={active ? classNames.button : classNames.greyButton}
        onClick={onClick}>
        {item}
      </button>

    )
  }
  render () {
    const { array } = this.props
    return (
      <div>
        {array.map(this.renderItem)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/ArrayPicker.js